import React, { type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import { TITLE_VARIANT_L, Title } from 'mailup-web-components'

import { paginationState } from 'Pages/GroupsList/recoil/state/state'

const Counter: FC = () => {
  const intl = useIntl()

  const { totalItems } = useRecoilValue(paginationState)

  return (
    <Title variant={TITLE_VARIANT_L}>{intl.formatNumber(totalItems)}</Title>
  )
}

export default Counter
